import * as angular from 'angular';
import { DigitalBoardingService } from './ib-digital-boarding-service';
import { FrequentFlyersCompaniesService } from './ib-frequent-flyers-companies-service';
import { MmBAirlinesLogoService } from './ib-MmB-airlines-logo-service';
import { CalculatePointsService } from './ib-Mmb-calculate-points-service';
import { CashRefundService } from './ib-Mmb-cash-refund-service';
import { MmbInvoluntaryChangeService } from './ib-mmb-involuntary-change-service';
import { VoucherInformationService } from './ib-Mmb-voucher-information-service';
import { ReshopConditionsService } from './ib-reshop-conditions-service';
import { RetrieveOrderService } from './ib-retrieve-order-service';
import { SisterCitiesService } from './ib-sister-cities-service';
import { DigitalMenuStatusService } from './ib-MmB-digital-menu-status-service';
import { ibCCalculatePointsService } from 'ib-web-commons/app/core/http-services/prlm-pc/ib-calculate-points-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { DEFAULT_SISTER_CITIES_REQUEST_MODEL, SisterCitiesRequestModel } from '@src/app/core/models/availability-model/sister-cities-request-model/sister-cities-request.model';
import { MMBDatalayerConstants } from './ib-MmB-datalayer/constants/ib-MmB-datalayer-constants';

@Service(
    'ib-MmB-services-module',
    ['FrequentFlyersCompaniesService',
        'CommonsCommercialInfobyMarketService',
        'RetrieveOrderService',
        'localStorageService',
        '$location',
        'MmBAppConstants',
        'MmBModalService',
        'MmBUtilService',
        'MmBAirlinesLogoService',
        '$cookies',
        '$rootScope',
        'MmbInvoluntaryChangeService',
        'BookingManagementService',
        'BookingNameService',
        'DigitalBoardingService',
        'CurrencyService',
        '$window',
        'IbFlagsTransformer',
        'VoucherInformationService',
        'CashRefundService',
        'SisterCitiesService',
        'CalculatePointsTransformer',
        'ChangleFlightsService',
        'CommonsAncillariesService',
        'ReshopConditionsService',
        '$filter',
        'CommonsModalService',
        'DigitalMenuStatusService',
        'ibCCalculatePointsService',
        'CalculatePointsService'],
    []
)
export class BookingSearchService {
    private reshopConditionsResponse : BehaviorSubject<any>;
    public readonly reshopConditionsResponseObser : Observable<any>;
    constructor (
        private FrequentFlyersCompaniesService: FrequentFlyersCompaniesService,
        private CommonsCommercialInfobyMarketService: CommonsCommercialInfobyMarketService,
        private RetrieveOrderService: RetrieveOrderService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $location: angular.ILocationService,
        private MmBAppConstants,
        private MmBModalService,
        private MmBUtilService,
        private MmBAirlinesLogoService: MmBAirlinesLogoService,
        private $cookies: angular.cookies.ICookiesService,
        private $rootScope: any,
        private MmbInvoluntaryChangeService: MmbInvoluntaryChangeService,
        private BookingManagementService,
        private BookingNameService,
        private DigitalBoardingService: DigitalBoardingService,
        private CurrencyService: CurrencyService,
        private $window: angular.IWindowService,
        private IbFlagsTransformer,
        private VoucherInformationService: VoucherInformationService,
        private CashRefundService: CashRefundService,
        private SisterCitiesService: SisterCitiesService,
        private CalculatePointsTransformer,
        private ChangleFlightsService,
        private CommonsAncillariesService: CommonsAncillariesService,
        private ReshopConditionsService: ReshopConditionsService,
        private $filter: ng.FilterFactory,
        private CommonsModalService: any,
        private DigitalMenuStatusService: DigitalMenuStatusService,
        private ibCCalculatePointsService: ibCCalculatePointsService,
        private CalculatePointsService: CalculatePointsService
    ) {
        this.reshopConditionsResponse = new BehaviorSubject({});
        this.reshopConditionsResponseObser = this.reshopConditionsResponse.asObservable();
    }

    searchFlightsPassengers = (surname, pnr, updateInvoiceInfo?) => {
        return new Promise((resolve, reject) => {
            const continueWithCommercialInfo = () => {
                this.CommonsCommercialInfobyMarketService.getCommercialInfo().then((commercialInfo) => {
                    this.localStorageService.set('commercialInfo', transformCommercialInfo(commercialInfo));
                    this.MmBAirlinesLogoService.getAirlinesLogos().then(() => getAirlinesFinish(resolve, reject), () => getAirlinesFinish(resolve, reject));
                }, (error) => serviceError(error, resolve, reject));
            };

            const getAirlinesFinish = (resolve, reject) => {
                const resolveData = (bookingData) => {

                    const setDataAboutBooking = (bookingData) => {
                        this.localStorageService.set('PNR', bookingData.order.bookingReferences[0].reference);
                        this.localStorageService.set('checkinSurname', bookingData.passengers[0].personalInfo.surname);
                    };

                    const bookingInfo = this.checkOrderInfo(bookingData);
                    if(this.localStorageService.get('deepLinkParams')) {
                        setDataAboutBooking(bookingData);
                    }

                    if (bookingInfo.isAirShuttle) {
                        resolve(bookingInfo);
                    } else {


                            if(bookingInfo.order.status === this.MmBAppConstants.SLICE_STATUS.ON_HOLD_CONFIRMABLE || bookingInfo.order.status === this.MmBAppConstants.SLICE_STATUS.HOLD || bookingInfo.order.status === this.MmBAppConstants.SLICE_STATUS.FRAUD_ONHOLD){
                                const resident = bookingData.order?.specialDiscounts?.filter((specialDiscount) => specialDiscount.type === 'RES')
                                // call flight calculation
                                const CalcServiceSuccess = (response) => {
                                    this.localStorageService.set(
                                        'CalculatedPoints',
                                        {
                                            ...this.CalculatePointsTransformer.TransCalcPointsData(response),
                                            resident: resident?.length > 0
                                        }
                                    );
                                    this.localStorageService.set(
                                        'CalculatedPointsForPassenger',
                                        this.CalculatePointsTransformer.TransCalcPointsForPassenger(response)
                                    );
                                    resolve(bookingInfo);
                                };
                                const CalcServiceFailure = (error) => {
                                    this.localStorageService.remove('CalculatedPoints');
                                    this.localStorageService.remove('CalculatedPointsForPassenger');
                                    resolve(bookingInfo);
                                };
                                const request = this.CalculatePointsTransformer.genCalAviosSummary(bookingData, null,null,true);
                                this.localStorageService.set('flightAviosInfo', request);
                                this.ibCCalculatePointsService
                                    .getCalculateFlightsAvios(request)
                                    .then(CalcServiceSuccess, CalcServiceFailure);

                            }else{
                                resolve(bookingInfo);
                            }

                            resolve(bookingInfo);
                    }

                    if (updateInvoiceInfo) this.$rootScope.$broadcast('updateInvoiceInfo');
                };

                const airShuttleCookie = this.$cookies.getObject(this.MmBAppConstants.COOKIES.CHECKIN_ID);
                const flightId = this.MmBUtilService.getParameterByName(this.MmBAppConstants.URL_PARAMETERS.FLIGHT_ID) || null;
                if (this.MmBUtilService.getParameterByName('step') && airShuttleCookie) {
                    this.RetrieveOrderService.retrieveOrderByCheckinId(airShuttleCookie.checkinId).then((bookingInfo) => {
                        this.$cookies.remove(this.MmBAppConstants.COOKIES.CHECKIN_ID, { path: this.MmBAppConstants.COOKIES.DEFAULT_PATH });
                        resolveData(bookingInfo);
                    }, (error) => serviceError(error, resolve, reject));
                } else if (this.localStorageService.get('deepLinkParams')) {
                    this.RetrieveOrderService.retrieveOrderByDeepLink(this.localStorageService.get('deepLinkParams')).then(resolveData, (error) => serviceError(error, resolve, reject));
                }
                else if(flightId){
                    this.RetrieveOrderService.retrieveOrderByFlightId(flightId).then(resolveData, (error) => serviceError(error, resolve, reject));
                } else {
                    // call import
                    this.RetrieveOrderService.retrieveOrderPost(surname, pnr).then(resolveData, (error) => serviceError(error, resolve, reject));
                }
            };

            const serviceError = (error, resolve, reject) => {
                const airShuttleCookie = this.$cookies.getObject(this.MmBAppConstants.COOKIES.CHECKIN_ID);
                let objectCookieError = {};
                if (this.MmBUtilService.getParameterByName('step') && airShuttleCookie) {
                    // if the entry point comes from CHECKIN PA and there is an error, come back to CHECKIN PA APP With error
                    objectCookieError = {
                        nextStep: airShuttleCookie.fromStep,
                        errorCode: this.MmBAppConstants.GDR_PA_ERRORS.ERR_1
                    };
                    sessionStorage.setItem(this.MmBAppConstants.COOKIES.AIR_SHUTTLE_ERROR, JSON.stringify(objectCookieError) );
                    sessionStorage.removeItem(this.MmBAppConstants.COOKIES.CHECKIN_ID);
                    this.localStorageService.set('externalRedirect', true);
                    reject(error);
                } else {
                    reject(error);
                }
            };

            const transformCommercialInfo = (commercialInfo) => {
                let i = 0, mFound = false, defaultMarket = {}, marketInfo;
                while (!mFound && i < commercialInfo.length) {
                    if (commercialInfo[i].market.code === this.MmBAppConstants.market) {
                        mFound = true;
                        marketInfo = commercialInfo[i];
                    } else if (commercialInfo[i].market.code === this.MmBAppConstants.defaultMarket) {
                        defaultMarket = commercialInfo[i];
                    }
                    i++;
                }
                return marketInfo || defaultMarket;
            };

            if (pnr && surname) {
                pnr = pnr.toUpperCase();
                this.localStorageService.set('PNR', pnr);
                this.localStorageService.set('checkinSurname', surname);
            }
            if (this.localStorageService.get('deepLinkParams')) {
                continueWithCommercialInfo();
            } else {
                this.FrequentFlyersCompaniesService.getFrequentFlyersCompanies().then(() => {
                    continueWithCommercialInfo();
                }, (error) => serviceError(error, resolve, reject));
            }
        });
    };

    checkOrderInfo = (bookingInfo) => {
        let airShuttleIndex = 0, airShuttleFound = false, segmentsInfo = { isAirShuttle: false, isOnHold: bookingInfo.order.status === this.MmBAppConstants.SLICE_STATUS.ON_HOLD_CONFIRMABLE || bookingInfo.order.status === this.MmBAppConstants.SLICE_STATUS.HOLD || bookingInfo.order.status === this.MmBAppConstants.SLICE_STATUS.FRAUD_ONHOLD };
        while (!airShuttleFound && airShuttleIndex < bookingInfo.order.slices.length) {
            airShuttleFound = bookingInfo.order.slices[airShuttleIndex].type === this.MmBAppConstants.SLICE_TYPES.SHUTTLE;
            airShuttleIndex++;
        }
        segmentsInfo.isAirShuttle = airShuttleFound;
        angular.extend(bookingInfo, segmentsInfo);
        return bookingInfo;
    };

    retrieveOrderComplete = (bookingData, data) => {
        if(data && data==="bookingName") this.MmBModalService.showWaitingModal();
        const continueFlow = () => {
            this.localStorageService.set('bookingInfo', bookingData);
            this.ChangleFlightsService.getDisruptionPeriods().then((response) => {
                this.localStorageService.set('disruptionPeriodsInfo', true);
                this.localStorageService.set('blackOutPeriodsData', response);
                this.localStorageService.set('textBlackoutPeriods', this.MmBUtilService.formatDisruptionAndFlexibilizationDates(response.blackOutPeriods, 'BLACKOUT'));
                this.localStorageService.set('textAllowedPeriods', this.MmBUtilService.formatDisruptionAndFlexibilizationDates(response.allowedPeriods, 'ALLOWED_PERIODS'));
                this.localStorageService.set('allowedPeriods', response.allowedPeriods);

                goAhead();
            }, (error) => {
                this.localStorageService.set('disruptionPeriodsInfo', false);
                goAhead();
            });

            const goAhead = () => {
                const locator = this.localStorageService.get('PNR');
                if (bookingData.isAirShuttle || (bookingData.isOnHold && checkMmbMarket(true)) || (!bookingData.isOnHold && !bookingData.isAirShuttle && checkMmbMarket(false))) {
                    this.localStorageService.set('bookingInfo', bookingData);
                    nextStep = getNextStep(bookingData);
                    if (nextStep === this.MmBAppConstants.PAGES_URL.MMB_INVOLUNTARY_CHANGE || nextStep === this.MmBAppConstants.PAGES_URL.MMB_DASHBOARD) {
                        //Get digitalBoarding info and save in localstorage
                        this.DigitalBoardingService.getDigitalBoardingAvailability(bookingData).then(getDigitalBoardingSuccess, getDigitalBoardingError);
                        //Get Ancillaries info and save in localstorage
                        this.CommonsAncillariesService.getAncillaries(undefined, locator).then(getAncillariesSucces, getAncillariesError);

                    } else {
                        if (this.$location.path() === nextStep) {
                            this.$window.location.reload();
                        } else {
                            this.$location.path(nextStep);
                        }

                    }

                } else {
                    const error = { message: 'REST_SERVICE_ERROR_GENERAL', needsTranslate: true };
                    const channel = this.localStorageService.get('channel');
                    this.MmBModalService.showWaitingModal();
                    this.MmBModalService.showGenericError(error).result.then(angular.noop, angular.noop);
                }
            };
        };

        const checkMmbMarket = (isOnHold) => {
            let indexOpenedMarkets = 0, actualMarket = this.$rootScope.appMarket, openedMarketsList, marketFound = false;

            isOnHold ? openedMarketsList = this.MmBAppConstants.ON_HOLD_MARKETS : openedMarketsList = this.MmBAppConstants.MMB_MARKETS;

            while (marketFound === false && indexOpenedMarkets < openedMarketsList.length) {
                if (openedMarketsList[indexOpenedMarkets] === actualMarket.replace('/', '')) {
                    marketFound = true;
                }
                indexOpenedMarkets++;
            }

            return marketFound;
        };

        const getNextStep = (bookingData) => {
            let stepParam = this.MmBUtilService.getParameterByName('step'), segmentIdParam = this.MmBUtilService.getParameterByName('segmentId'), returnedStep;
            let flowTitlesApp = this.MmBAppConstants.TITLES_APP.MANAGEMYBOOKING_ANCILLARIES, ibvProduct = false;

            this.$rootScope.isDisruptionFlow = false;
            if (bookingData.isOnHold) {
                this.localStorageService.set('flowApp', 'MMBOH');
                returnedStep = this.MmBAppConstants.PAGES_URL.CONFIRM_ON_HOLD;
            } else if (bookingData.isAirShuttle) {
                flowTitlesApp = this.MmBAppConstants.TITLES_APP.SHUTTLE;
                returnedStep = this.MmBAppConstants.PAGES_URL.BOOKING_MANAGE;
            } else if (this.isDisruptionOrder(bookingData)) {
                this.localStorageService.set('flowApp', 'MMBANC');
                this.localStorageService.set('rebookDisable', false);
                this.$rootScope.isDisruptionFlow = true;
                ibvProduct = this.checkIBVProduct (bookingData);
                if (ibvProduct) {
                    returnedStep = this.MmBAppConstants.PAGES_URL.MMB_INVOLUNTARY_CHANGE;
                } else {
                    returnedStep = this.MmBAppConstants.PAGES_URL.DISRUPTION_DASHBOARD;
                }
            } else if (this.MmbInvoluntaryChangeService.hasInvoluntaryChange(bookingData.order.status)) {
                this.localStorageService.set('flowApp', 'MMBANC');
                returnedStep = this.MmBAppConstants.PAGES_URL.MMB_INVOLUNTARY_CHANGE;
            } else {
                returnedStep = this.MmBAppConstants.PAGES_URL.MMB_DASHBOARD;
            }
            this.localStorageService.set('flowTitlesApp', flowTitlesApp);
            if (stepParam) {
                switch (stepParam) {
                        case this.MmBAppConstants.STEP_PARAM_VALUES.CHANGE_FLIGHT:
                            if (segmentIdParam) {
                                this.localStorageService.set('checkinSegmentId', segmentIdParam);
                                this.$location.search({});
                            }
                            break;
                }
            }
            return returnedStep;
        };

        const getAncillariesSucces = (ancillariesResponse) => {
            const locator = this.localStorageService.get('PNR');
            const isRefreshCall = this.localStorageService.get('isRefreshCall') || null;
            const flightAviosInfoObject = this.CalculatePointsTransformer.genCalAviosSummary(bookingData, ancillariesResponse.slices, bookingData.order.orderItems);
            this.localStorageService.set('flightAviosInfo', flightAviosInfoObject);
            const ancillariesInfo = ancillariesResponse;
            this.localStorageService.set('ancillariesInfo', ancillariesInfo);
            if (this.localStorageService.get('sendReloadEvent')) {
                this.$rootScope.$broadcast('reloadMMBDashboard');
            }

            this.CommonsAncillariesService.getAncillarieSummary(undefined, isRefreshCall, locator).then(getAncillarieSummarySuccess, getAncillariesError);
        };

        const getDigitalBoardingSuccess = (digitalBoardingResponse) => {
            this.localStorageService.remove('digitalBoardingInfo');
            if (digitalBoardingResponse.hasData) {
                this.localStorageService.set('digitalBoardingInfo', digitalBoardingResponse.data);
                this.$rootScope.$broadcast('showBoxYourDocuments');
            }
        };

        const getAncillarieSummarySuccess = (breakdownResponse) => {
            let breakdownInfo = breakdownResponse;
            let currency: any = {};
            this.checkPreorder(breakdownResponse);
            breakdownResponse.currencies[0] ? currency = breakdownResponse.currencies[0] : currency = bookingData.contextMetadata.currencies[0];
            this.localStorageService.set('breakdownInfo', breakdownInfo);
            this.localStorageService.set('currency', this.CurrencyService.getCurrencyObject(currency));
            this.BookingManagementService.getBookingInfo().then(BookingManagementSucces, BookingManagementError);
        };

        const BookingManagementSucces = (managementResponse) => {
            this.DigitalMenuStatusService.getDigitalMenuStatus(bookingData.flowId).then(digitalMenuStatusSuccess, digitalMenuStatusError);
        };

        const BookingManagementError = () => {
            this.DigitalMenuStatusService.getDigitalMenuStatus(bookingData.flowId).then(digitalMenuStatusSuccess, digitalMenuStatusError);
        };

        const digitalMenuStatusSuccess = (digitalMenuStatusResponse) => {
            this.localStorageService.set('digitalMenuStatus', digitalMenuStatusResponse);
            this.$rootScope.$broadcast('reloadMMBDashboard');
            this.$location.path(nextStep);
        };

        const digitalMenuStatusError = () => {
            this.localStorageService.set('digitalMenuStatus', null);
            this.$rootScope.$broadcast('reloadMMBDashboard');
            this.$location.path(nextStep);
        };

        const getAncillariesError = () => {
            const deepLinkFlow = this.localStorageService.get('deepLinkParams') ? true : false;
            this.localStorageService.set('breakdownInfo', null);
            this.localStorageService.set('ancillariesInfo', null);
            if (deepLinkFlow) {
                this.$rootScope.$broadcast('modalDeepLinkErrorEvent');
            } else {
                this.$rootScope.$broadcast('reloadMMBDashboard');
                this.$location.path(nextStep);
            }
            this.DigitalMenuStatusService.getDigitalMenuStatus(bookingData.flowId).then(digitalMenuStatusSuccess, digitalMenuStatusError);
        };

        const getDigitalBoardingError = () => {
            this.localStorageService.set('digitalBoardingInfo', null);
        };

        /**
         * Transforms voucher price information and if there is cash refund option, calls the function to transform cash price info; otherwise, the flow continues.
         * @param {Object} voucherInfoResponse | Voucher price information
         */
        const setVoucherPrice = (voucherInfoResponse) => {
            let voucherOrderItems = null, i, voucherPercentage = 0;
            if (voucherInfoResponse.price != null) {
                for (i = 0; i < voucherInfoResponse.orderItems.length; i++) {
                    if (voucherInfoResponse.orderItems[i].subtype === 'VOUCHER_REFUND') {
                        voucherPercentage = voucherInfoResponse.orderItems[i].percentage;
                    }
                }
                if(voucherPercentage === 0) {
                    voucherPercentage = voucherInfoResponse.price.refundPercent;
                }
                this.localStorageService.set('voucherOrderItemsPrice', voucherPercentage);
            }
            voucherOrderItems = voucherInfoResponse.refundedOrderItems;
            this.localStorageService.set('voucherEmailNotification', haveMail(voucherInfoResponse.notifications));
            this.localStorageService.set('voucherOrderItems', voucherOrderItems);
            this.localStorageService.set('voucherCurrenciesList', voucherInfoResponse.currencies);
            this.localStorageService.set('voucherList', voucherInfoResponse.vouchers);
            this.localStorageService.set('refundFees', voucherInfoResponse.refundFees);
            if (voucherInfoResponse.price && voucherInfoResponse.price.fare && voucherInfoResponse.price.currency) {
                this.MmBUtilService.transformVoucherPriceInfo(voucherInfoResponse.price, voucherInfoResponse.currencies, voucherInfoResponse.partialRefund, voucherInfoResponse.totalPrice);
            }
            if (flagsInfo.showCashRefundOnline) {
                getCashRefundAmountInformation();
            } else {
                continueFlow();
            }
        };

        const haveMail = (notifications) => {
            let i, result = false;
            for (i = 0; i < notifications.length; i++) {
                if (notifications[i].email) {
                    result = true;
                }
            }
            return result;
        };

        const getCashRefundAmountInformation = () => {
            this.CashRefundService.getCashRefundInformation(bookingData.flowId, refundsRequest).then(generateCashRefundInformation, continueFlow);
        };

        const generateCashRefundInformation = (cashRefundResponse) => {
            this.localStorageService.set('cashEmailNotification', haveMail(cashRefundResponse.notifications));
            this.localStorageService.set('cashOrderItems', cashRefundResponse.orderItems);
            this.localStorageService.set('cashCurrenciesList', cashRefundResponse.currencies);
            cashRefundResponse.refundTotalAmountInfos && cashRefundResponse.currencies ?
                this.MmBUtilService.transformCashPriceInfo(cashRefundResponse.refundTotalAmountInfos, cashRefundResponse.currencies) : angular.noop;

            continueFlow();
        };

        let nextStep, flagsInfo, refundsRequest = { flowId: '' }, showSisterCitiesPossibility = false, sisterCitiesRequest, allowSisterCities = false;
        this.localStorageService.set('flowId', bookingData.flowId);
        this.localStorageService.set('pnrChannel', bookingData.channel);

        flagsInfo = this.IbFlagsTransformer.generateFlagsMenu(bookingData);

        if (bookingData && bookingData.isAirShuttle !== true) {
            this.ReshopConditionsService.getReshopConditions(bookingData.flowId).then((response: any) => {
                if (response.flightChangeCapabilities) {
                    this.localStorageService.set('reshopConditions', response.flightChangeCapabilities);
                    this.reshopConditionsResponse.next(response.flightChangeCapabilities);
                }
                if (response.disruptionSeatChangeCapabilites) {
                    this.localStorageService.set('disruptionSeatChangeCapabilities', response.disruptionSeatChangeCapabilites);
                } else {
                    this.localStorageService.remove('disruptionSeatChangeCapabilities');
                }
            }, angular.noop);
        }

        const getVoucherAndCashData = () => {
            this.localStorageService.set('showSisterCitiesPossibility', showSisterCitiesPossibility);
            if (flagsInfo.showRefundVoucherSection) {
                refundsRequest.flowId = bookingData.flowId;
                this.VoucherInformationService.getVoucherAmount(bookingData.flowId, refundsRequest).then(setVoucherPrice, continueFlow);
            } else if (flagsInfo.showCashRefundOnline) {
                refundsRequest.flowId = bookingData.flowId;
                this.CashRefundService.getCashRefundInformation(bookingData.flowId, refundsRequest).then(generateCashRefundInformation, continueFlow);
            } else {
                continueFlow();
            }
        };

        if (flagsInfo.sisterCitiesData && flagsInfo.sisterCitiesData.hasSistercitiesPossibility) {
            allowSisterCities = this.MmBUtilService.getFlagValue(bookingData.orderFlags, 'type', 'enabled', 'ALLOWED_SISTER_CITIES');
            if (allowSisterCities) {
                if (flagsInfo.sisterCitiesData.allowedSlices && flagsInfo.sisterCitiesData.allowedSlices.length >= 1) {
                    sisterCitiesRequest = this.createSisterCitiesRequest(flagsInfo.sisterCitiesData.allowedSlices, this.isDisruptionOrder(bookingData), bookingData);
                    this.SisterCitiesService.getSisterCities(sisterCitiesRequest).then((response) => {
                        showSisterCitiesPossibility = this.isSisterCitiesEnabled(response);
                        this.localStorageService.set('sisterCitiesRawModel', response);
                        getVoucherAndCashData();
                    }, getVoucherAndCashData);
                } else {
                    getVoucherAndCashData();
                }
            } else {
                getVoucherAndCashData();
            }
        } else {
            getVoucherAndCashData();
        }
    };


        /**
    * Return preconditions to call sister cities endpoint returning if is specific or generic or none
    * @param {Object} bookingInfo Object with date values
    * @returns {Object} 'preconditions sister cities enum' with information to make sister cities request.
    */
     private getDisruptionType (bookingInfo){
            const disruptionType = {
                'disruptionType': '',
                'disruptionId': ''
            };
            return disruptionType;
        }

    /**
     *
     * @param {Array} sisterCitiesAllowedSlices
     * The function creates the request for the sister cities service. The list has unique elements to make sure we are not sending duplicate city
     * codes in the request, and to map the results easier.
     */
    private createSisterCitiesRequest (sisterCitiesAllowedSlices, isDisruption, bookingData) : SisterCitiesRequestModel {

        let disruptionParams = this.MmBUtilService.getDisruptionType(bookingData);
        let sliceOrigin, sliceDestination, tempSisterCitiesList = []
        let  sistCitiesFilterRequest : SisterCitiesRequestModel = DEFAULT_SISTER_CITIES_REQUEST_MODEL;
        angular.forEach(sisterCitiesAllowedSlices, (slice) => {
            sliceOrigin = null, sliceDestination = null;

            if (isDisruption && slice.originalDisruptionSliceInformation) {
                sliceOrigin = slice.originalDisruptionSliceInformation.departure.city.code;
                sliceDestination = slice.originalDisruptionSliceInformation.arrival.city.code;
            } else {
                sliceOrigin = slice.segments[0].departureCity.code;
                sliceDestination = slice.segments[slice.segments.length - 1].arrivalCity.code;
            }


            tempSisterCitiesList.push(sliceOrigin, sliceDestination);
        });
        sistCitiesFilterRequest.cities = tempSisterCitiesList.filter((item, index) => {
            return tempSisterCitiesList.indexOf(item) >= index;
        });

        sistCitiesFilterRequest.disruptionType = disruptionParams.disruptionType;
        sistCitiesFilterRequest.disruptionId = disruptionParams.disruptionId;
        return sistCitiesFilterRequest;
    };

    /**
     * Makes the search of the received pnr and surname and show modal for confirm data if
     * have more of one passenger
     * @param {Object} event the received event
     * @param {Object} data the event data
     */
    searchFlightsPassengersEvent = (event, data) => {
        this.MmBModalService.showWaitingModal();
        this.searchFlightsPassengers(data.surname, data.pnr, data.updateInvoiceInfo).then((bookingData) => {
            this.retrieveOrderComplete(bookingData, data);
        }, (error) => {
            this.MmBModalService.finishWaiting();
            if (error.errorCode === 500) {
                error.message = this.MmBAppConstants.GENERAL_ERRORS_SERVICE.SERVICE_GENERAL_ERROR;
                error.needsTranslate = true;
                this.CommonsModalService.showGenericError(error, true, null);
            } else if (error.errorCode === 412) {
                this.MmBModalService.showGenericModal(true, 'ib-info-confidentiality-modal.html', { confirmation: error.setErrors, idModal: MMBDatalayerConstants.DATALAYER_MODAL_ID.INFO_CONFIDENTIALITY }).result.then(() => {
                    this.MmBModalService.showWaitingModal();
                    this.RetrieveOrderService.retrieveOrderConsent(error.flowId).then((bookingData) => {
                        this.retrieveOrderComplete(this.checkOrderInfo(bookingData), data);
                        this.MmBModalService.finishWaiting();
                    }, angular.noop);
                }, this.MmBModalService.finishWaiting);
            } else if (error.errorCode === 410 && error.internalErrorCode.startsWith('SSE_ORM')) {
                error.title = this.$filter('translate')('MMB_FLEXIBILIZATION_ERROR_MODAL_TITLE');
                this.CommonsModalService.showGenericError(error, true, null);
            } else if (error.errorCode === 409 && error.internalErrorCode === this.MmBAppConstants.WARNING_MESSAGES.SAME_SURNAME_WARNING) {
                let flowId= null;
                this.MmBModalService.finishWaiting();
                flowId = this.localStorageService.get('flowId');
                this.BookingNameService.checkName(data.surname,flowId);
            } else {
                error.title = this.$filter('translate')('MMB_FLEXIBILIZATION_ERROR_MODAL_TITLE');
                this.CommonsModalService.showGenericError(error, true, null);
            }
        });
    };

    private checkPreorder = (breakdownResponse) => {
        if (breakdownResponse.issuedItems.length > 0) {
            for (let i = 0; i < breakdownResponse.issuedItems.length; i++) {
                if (breakdownResponse.issuedItems[i].type === 'PREORDER') {
                    this.localStorageService.set('hasPreorderAncillarie', true);
                }
            }
        }
    };

    private checkIBVProduct = (bookingData) => {
        let ibvProduct = false, i;
        if (bookingData.qualifiers) {
            for (i = 0; i < bookingData.qualifiers.length; i++) {
                if (bookingData.qualifiers[i].name === 'IBDPHOLIDAYS') {
                    ibvProduct = true;
                }
            }
        }
        return ibvProduct;
    }

    /**
     * Validates if the order is a Disruption type
     * @param {Object} Order The order to validate
     * @returns {boolean} True in case the order fits the disruption scenario
     */
    private isDisruptionOrder = (data) => {
        var isDisruption = false, isSpecialOrderStatus = false, hasTickets = true;
        //Remove
        //data.tickets = null;
        switch (data.order.status) {
            case this.MmBAppConstants.ORDER_STATUS_VALUES.CANCELATION_FLAG:
                isDisruption = true;
                break;
            case this.MmBAppConstants.ORDER_STATUS_VALUES.CANCELATION_REACOM_FLAG:
                isDisruption = true;
                break;
            case this.MmBAppConstants.ORDER_STATUS_VALUES.SCHEDULE_CHANGE:
                isDisruption = true;
                break;
            case this.MmBAppConstants.ORDER_STATUS_VALUES.CANCELATION_MIXED_CHANGE:
                isDisruption = true;
                break;
            case this.MmBAppConstants.ORDER_STATUS_VALUES.CANCELATION_REACOM_MIXED_CHANGE:
                isDisruption = true;
                break;
            case this.MmBAppConstants.ORDER_STATUS_VALUES.CANCELATION_CHANGES:
                isDisruption = true;
                isSpecialOrderStatus = !data.tickets ? true : false;
                break;
            case this.MmBAppConstants.ORDER_STATUS_VALUES.WAITLIST_CONFIRMED_CHANGES:
                isDisruption = true;
                isSpecialOrderStatus = !data.tickets ? true : false;
                break;
            case this.MmBAppConstants.ORDER_STATUS_VALUES.DISRUPTION_CHANGES_MIXED:
                isDisruption = true;
                break;
        }
        hasTickets = data.tickets ? true : false;
        this.localStorageService.set('hasTickets', hasTickets);
        this.checkIsNotIberiaTicket(data.flexibilizationCapabilitiesInformation, data.genericDisruptionCapabilitiesInformation, data.order.status, data.tickets);
        return isDisruption;
    };

    /**
     * Checks if the PNR is from an agency (due to new general disruptions).
     */
    private checkIsNotIberiaTicket = (flexibilizationCapabilitiesInformation, genericDisruptionCapabilitiesInformation, orderStatus, tickets) => {
        var notIberiaTicket = false;

        if (!flexibilizationCapabilitiesInformation && !genericDisruptionCapabilitiesInformation) {
            notIberiaTicket = true;
        }

        if (orderStatus === this.MmBAppConstants.ORDER_STATUS_VALUES.WAITLIST_CONFIRMED_CHANGES || orderStatus === this.MmBAppConstants.ORDER_STATUS_VALUES.CANCELATION_CHANGES) {
            if (!tickets) {
                notIberiaTicket = false;
            }
        }

        this.localStorageService.set('notIberiaTicket', notIberiaTicket);
    };

    private isSisterCitiesEnabled = (sisterResponse) => {
        var returnValue, cityIndex;
        returnValue = false;
        cityIndex = 0;
        if (sisterResponse && sisterResponse.cities) {
            for (cityIndex = 0; cityIndex < sisterResponse.cities.length; cityIndex++) {
                if (sisterResponse.cities[cityIndex].sisterCities && sisterResponse.cities[cityIndex].sisterCities.length > 0) {
                    returnValue = true;
                }
            }
        }
        return returnValue;
    };
}
